import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import {
  Table,
  Icon,
  Alert,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  NotificationManager,
  Spinner,
} from "design-react-kit";

import secureLocalStorage from "react-secure-storage";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";
import {
  downloadFlow,
  filterHandler,
  showFlowType,
  showStatus,
} from "../../services/helpers";
import StagedFlowStatusEnum from "../../helpers/Enums/StagedFlowStatusEnum";
import UserContext from "../../store/user-context";
import { useSignIn, useSignOut } from "react-auth-kit";
import AuthModuleConfirmModal from "../Modals/AuthModuleConfirmModal";

const AuthModuleFlowsEconTable = ({ items, columns, getFlows }) => {
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [flowModalOpen, setFlowModalOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [text, setText] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    setResults(items);
  }, [items]);

  const flowModalOpenHandler = (flow, status, text) => {
    const dropdowns = document.querySelectorAll(".dropdown-menu");

    dropdowns.forEach((item) => item.classList.remove("show"));

    setSelectedFlow(flow);
    setStatus(status);
    setText(text);
    setFlowModalOpen(true);
  };

  const flowModalCloseHandler = () => {
    setFlowModalOpen(false);
    setSelectedFlow(null);
  };

  return (
    <Fragment>
      {error !== null && error.length !== undefined && (
        <Alert color="danger" className="w-50 ml-auto mr-auto">
          {error.map((item) => (
            <p key={item}>{item}</p>
          ))}
        </Alert>
      )}

      {isLoading && (
        <p
          style={{
            height: "50px",
            position: "relative",
            marginBottom: "3rem",
          }}
        >
          <Spinner double active />
        </p>
      )}
      <div className="d-flex flex-column align-items-end justify-content-start w-100">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Cerca per nome del flusso"}
            column={"name"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getFlows()}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.id}>
                    <td className="predispositionDate">
                      {result.predispositionDate}
                    </td>
                    <td className="name">{result.name}</td>
                    <td className="clientCodeName">{result.clientCodeName}</td>
                    <td className="flowType">
                      {showFlowType(result.flowType)}
                    </td>
                    <td className="countDigNotifications text-center">
                      {result.countDigNotifications === null
                        ? 0
                        : result.countDigNotifications}
                    </td>
                    <td
                      className="totalPlatformCost text-center"
                      title={`Costo calcolato: ${result.totalPlatformCost}€ * ${result.digitalCoefficient}`}
                    >
                      {`${
                        result.totalPlatformCost === null
                          ? `0.00`
                          : (
                              result.totalPlatformCost *
                              result.digitalCoefficient
                            ).toFixed(2)
                      }€`}
                    </td>
                    <td className="countAnNotifications text-center">
                      {result.countAnNotifications === null
                        ? 0
                        : result.countAnNotifications}
                    </td>
                    <td
                      className="totalAnalogicalCost text-center"
                      title={`Costo calcolato: ${result.totalAnalogicalCost}€ * ${result.analogicalCoefficient}`}
                    >
                      {`${
                        result.totalAnalogicalCost === null
                          ? `0.00`
                          : (
                              result.totalAnalogicalCost *
                              result.analogicalCoefficient
                            ).toFixed(2)
                      }€`}
                    </td>
                    <td className="totalCost text-center">
                      {`${(
                        result.totalPlatformCost * result.digitalCoefficient +
                        result.totalAnalogicalCost *
                          result.analogicalCoefficient
                      ).toFixed(2)}€`}
                    </td>
                    <td className="status text-center">{showStatus(result)}</td>
                    {result.stagedFlowStatusId ===
                      StagedFlowStatusEnum.ReadyForEconAuthorization && (
                      <td className="text-center initAuthflowsDropdown">
                        <UncontrolledDropdown className="table-dropdown">
                          <DropdownToggle>
                            <Icon icon="it-more-actions" fill="#06c" />
                            <Link to={null} className="moreActions ">
                              Vedi azioni
                            </Link>
                          </DropdownToggle>
                          <DropdownMenu>
                            <div
                              className="d-flex align-items-center ml-2"
                              id="readyState"
                            >
                              <Icon icon="it-arrow-right-circle" fill="#06c" />
                              <Link
                                to={null}
                                className="start-authorization text-nowrap"
                                onClick={(e) =>
                                  flowModalOpenHandler(
                                    result,
                                    StagedFlowStatusEnum.EconAuthInProgress,
                                    "Confermi l'inizio del processo di verifica finanziaria?",
                                  )
                                }
                              >
                                Inizia verifica
                              </Link>
                            </div>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    )}
                    {result.stagedFlowStatusId ===
                      StagedFlowStatusEnum.EconAuthInProgress && (
                      <td className="text-center authflowsEconDropdown">
                        <UncontrolledDropdown className="table-dropdown">
                          <DropdownToggle>
                            <Icon icon="it-more-actions" fill="#06c" />
                            <Link to={null} className="moreActions">
                              Vedi azioni
                            </Link>
                          </DropdownToggle>
                          <DropdownMenu>
                            <>
                              <div
                                className="d-flex align-items-center ml-2"
                                onClick={(e) => {
                                  secureLocalStorage.setItem(
                                    "flowName",
                                    result.name,
                                  );
                                  navigate(
                                    `/authModule/economicalFlows/notifications/${result.clientCodeName}/${result.id}/${result.flowType}`,
                                  );
                                }}
                              >
                                <Icon icon="it-password-visible" fill="#06c" />
                                <Link
                                  to={null}
                                  className="vediNotifiche"
                                  onClick={(e) =>
                                    navigate(
                                      `/authModule/economicalFlows/notifications/${result.clientCodeName}/${result.id}/${result.flowType}`,
                                    )
                                  }
                                >
                                  Vedi notifiche
                                </Link>
                              </div>
                              <hr />
                              <div
                                className="d-flex align-items-center ml-2"
                                style={{ cursor: "pointer" }}
                              >
                                <Icon icon="it-download" fill="#06c" />
                                <Link
                                  to={null}
                                  className="download text-nowrap"
                                  onClick={(e) =>
                                    downloadFlow(
                                      "DownloadFlow",
                                      result.id,
                                      setIsLoading,
                                      signIn,
                                      signOut,
                                      navigate,
                                      userContext,
                                      setError,
                                    )
                                  }
                                >
                                  Scarica flusso (dati)
                                </Link>
                              </div>
                              <div
                                className="d-flex align-items-center ml-2"
                                style={{ cursor: "pointer" }}
                              >
                                <Icon icon="it-download" fill="#06c" />
                                <Link
                                  to={null}
                                  className="download text-nowrap"
                                  onClick={(e) =>
                                    downloadFlow(
                                      "DownloadDocuments",
                                      result.id,
                                      setIsLoading,
                                      signIn,
                                      signOut,
                                      navigate,
                                      userContext,
                                      setError,
                                    )
                                  }
                                >
                                  Scarica flusso (allegati)
                                </Link>
                              </div>
                              <hr />
                              <div className="d-flex align-items-center ml-2">
                                <Icon icon="it-arrow-left-circle" fill="#06c" />
                                <Link
                                  to={null}
                                  className="return-to-tech text-nowrap"
                                  onClick={(e) =>
                                    flowModalOpenHandler(
                                      result,
                                      StagedFlowStatusEnum.EconNotApproved,
                                      "Sei sicuro di voler restituire il flusso all'autorizzazione tecnica?",
                                    )
                                  }
                                >
                                  Ritorna all'autorizzazione tecnica
                                </Link>
                              </div>
                              <hr />
                              <div className="d-flex align-items-center ml-2">
                                <Icon icon="it-check-circle" fill="#06c" />
                                <Link
                                  to={null}
                                  className="authorize text-nowrap"
                                  onClick={(e) =>
                                    flowModalOpenHandler(
                                      result,
                                      StagedFlowStatusEnum.EconAuthorized,
                                      "Sei sicuro di voler concedere l'autorizzazione finanziaria",
                                    )
                                  }
                                >
                                  Concedi autorizzazione
                                </Link>
                              </div>
                            </>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    )}
                  </tr>
                );
              })}
            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <AuthModuleConfirmModal
          confirmModalOpen={flowModalOpen}
          confirmModalCloseHandler={flowModalCloseHandler}
          stagedFlowId={selectedFlow?.id}
          target={selectedFlow?.name}
          error={error}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setError={setError}
          getFlows={getFlows}
          status={status}
          text={text}
        />
      </div>
      <div>
        <NotificationManager
          containerId="table-user-message"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
    </Fragment>
  );
};

export default AuthModuleFlowsEconTable;
